var map = {
	"./": [
		53,
		9
	],
	"./App": [
		55,
		9
	],
	"./App.css": [
		117,
		7
	],
	"./App.js": [
		55,
		9
	],
	"./App.test": [
		190,
		9,
		0,
		3,
		7
	],
	"./App.test.js": [
		190,
		9,
		0,
		3,
		7
	],
	"./Router": [
		69,
		9
	],
	"./Router.js": [
		69,
		9
	],
	"./components/Accordion": [
		191,
		9,
		8
	],
	"./components/Accordion.js": [
		191,
		9,
		8
	],
	"./components/ButtonArrow": [
		192,
		9,
		9
	],
	"./components/ButtonArrow.js": [
		192,
		9,
		9
	],
	"./components/ButtonShare": [
		193,
		9,
		10
	],
	"./components/ButtonShare.js": [
		193,
		9,
		10
	],
	"./components/Buttons": [
		18,
		9
	],
	"./components/Buttons.js": [
		18,
		9
	],
	"./components/Chart": [
		73,
		9
	],
	"./components/Chart.js": [
		73,
		9
	],
	"./components/Column": [
		194,
		9,
		11
	],
	"./components/Column.js": [
		194,
		9,
		11
	],
	"./components/Components": [
		13,
		9
	],
	"./components/Components.js": [
		13,
		9
	],
	"./components/Container": [
		75,
		9
	],
	"./components/Container.js": [
		75,
		9
	],
	"./components/ExtLink": [
		195,
		9,
		12
	],
	"./components/ExtLink.js": [
		195,
		9,
		12
	],
	"./components/Flip": [
		196,
		9,
		13
	],
	"./components/Flip.js": [
		196,
		9,
		13
	],
	"./components/Questions": [
		22,
		9
	],
	"./components/Questions.js": [
		22,
		9
	],
	"./components/Radio": [
		197,
		9,
		14
	],
	"./components/Radio.js": [
		197,
		9,
		14
	],
	"./components/Results": [
		56,
		9
	],
	"./components/Results.js": [
		56,
		9
	],
	"./components/Scoring": [
		72,
		9
	],
	"./components/Scoring.js": [
		72,
		9
	],
	"./components/Slider": [
		198,
		9,
		4,
		15
	],
	"./components/Slider.js": [
		198,
		9,
		4,
		15
	],
	"./components/Snackbar": [
		181,
		9,
		5
	],
	"./components/Snackbar.js": [
		181,
		9,
		5
	],
	"./components/Social": [
		199,
		9,
		16
	],
	"./components/Social.js": [
		199,
		9,
		16
	],
	"./components/Spinner": [
		71,
		9
	],
	"./components/Spinner.js": [
		71,
		9
	],
	"./components/Tabs": [
		200,
		9,
		6
	],
	"./components/Tabs.js": [
		200,
		9,
		6
	],
	"./components/menu.css": [
		119,
		7
	],
	"./components/snackbar.module.css": [
		414,
		7,
		26
	],
	"./components/styles.css": [
		118,
		7
	],
	"./components/tabs.css": [
		415,
		7,
		24
	],
	"./customization/Config": [
		3,
		9
	],
	"./customization/Config.js": [
		3,
		9
	],
	"./customization/about_customization.md": [
		417,
		9,
		28
	],
	"./helpers/Font": [
		87,
		9
	],
	"./helpers/Font.js": [
		87,
		9
	],
	"./helpers/Storage": [
		38,
		9
	],
	"./helpers/Storage.js": [
		38,
		9
	],
	"./index": [
		53,
		9
	],
	"./index.css": [
		115,
		7
	],
	"./index.js": [
		53,
		9
	],
	"./logo.svg": [
		116,
		9
	],
	"./pages/FrontPage": [
		86,
		9,
		1
	],
	"./pages/FrontPage/": [
		86,
		9,
		1
	],
	"./pages/FrontPage/index": [
		86,
		9,
		1
	],
	"./pages/FrontPage/index.js": [
		86,
		9,
		1
	],
	"./pages/FrontPage/koji": [
		201,
		3,
		18
	],
	"./pages/FrontPage/koji.json": [
		201,
		3,
		18
	],
	"./pages/FrontPage/styles.css": [
		416,
		7,
		25
	],
	"./pages/InfoPage": [
		39,
		9
	],
	"./pages/InfoPage/": [
		39,
		9
	],
	"./pages/InfoPage/index": [
		39,
		9
	],
	"./pages/InfoPage/index.js": [
		39,
		9
	],
	"./pages/InfoPage/koji": [
		202,
		3,
		19
	],
	"./pages/InfoPage/koji.json": [
		202,
		3,
		19
	],
	"./pages/InfoPage/styles.css": [
		141,
		7
	],
	"./pages/ResultPage": [
		37,
		9
	],
	"./pages/ResultPage/": [
		37,
		9
	],
	"./pages/ResultPage/index": [
		37,
		9
	],
	"./pages/ResultPage/index.js": [
		37,
		9
	],
	"./pages/ResultPage/koji": [
		203,
		3,
		20
	],
	"./pages/ResultPage/koji.json": [
		203,
		3,
		20
	],
	"./pages/SharePage": [
		40,
		9
	],
	"./pages/SharePage/": [
		40,
		9
	],
	"./pages/SharePage/index": [
		40,
		9
	],
	"./pages/SharePage/index.js": [
		40,
		9
	],
	"./reportWebVitals": [
		76,
		9
	],
	"./reportWebVitals.js": [
		76,
		9
	],
	"./setupTests": [
		204,
		9,
		0,
		2,
		17
	],
	"./setupTests.js": [
		204,
		9,
		0,
		2,
		17
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 413;
module.exports = webpackAsyncContext;